import { GoodUnits } from "../../graphql/generated";

function isLiquidUnit(unit: GoodUnits) {
  return [GoodUnits.Gallons, GoodUnits.Liters].includes(unit);
}

export default isLiquidUnit;
